export const buildTime = '2026-09-14 15:14:58 UTC';
